<div class="container pt-5">
    <div class="jumbotron">
        <h1 class="display-4">404</h1>
        <p class="lead">Diese Seite wurde nicht gefunden.</p>
        <hr class="my-4">
        <a class="btn btn-primary btn-lg" routerLink="/">Zurück zur Startseite</a>
    </div>
</div>